angular.module('workflow')
    .component('workflowList', {
        bindings: {
            page: '<',
            filters: '<',
            statistics: '<'
        },
        templateUrl: 'app/workflow/list.html',
        controller: function ($scope, $stateParams, Workflow, WorkflowService, Principal) {
            this.WorkflowService = WorkflowService
            this.reset = () => this.filters = {filter: this.filters.filter}

            this.$onInit = () => {
                this.canOpenSettings = Principal.hasAnyAuthority(["ROLE_WORKFLOW_SETTINGS"])
                this.directions = WorkflowService.getDirections()
            }

            this.refresh = () => {
                Workflow.table($stateParams).$promise.then(page => this.page = page)
                Workflow.tableStatistics($stateParams).$promise.then(statistics => this.statistics = statistics)
            }

            $scope.$on('workflow.updated', () => this.refresh())
            $scope.$on('workflow.deleted', () => this.refresh())
        }
    })
